import React from "react"
import { ButtonWrap } from "./timedbutton.styled"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

export const TimedButton = ({
  index,
  activeButtonIndex,
  isPaused,
  button,
  onClick,
}) => (
  <ButtonWrap
    className={`rounded ${index === activeButtonIndex ? "active" : "inactive"}`}
    onClick={onClick}
  >
    <TextElementNova element="h4" className="CTA-20-Dia-Normal" text={button} />
    {!isPaused && <span className="rounded progress"></span>}
  </ButtonWrap>
)
